import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AppSettings} from "../../config/config";
import {map} from 'rxjs/operators';

@Injectable()
export class ExamService{

  private _url = AppSettings.API_ENDPOINT;

  constructor(private http: HttpClient){}

  countOfExamAndCategoryService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/countOfExamAndCategory',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  examCategoryListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/examCategoryList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createExamCategoryService(examCategoryData,AUTHTOKEN){
    const params = examCategoryData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createExamCategory',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  updateExamCategoryService(examCategoryId,examCategoryName,current_academic,AUTHTOKEN){
    const params = {examCategoryId:examCategoryId,examCategoryName:examCategoryName,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/updateExamCategory',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  deleteExamCategoryService(examCategoryId,current_academic,AUTHTOKEN){
    const params = {examCategoryId:examCategoryId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/deleteExamCategory',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamBoardByCategoryService(examCategoryId,current_academic,AUTHTOKEN){
    const params = {ExamCategoryId:examCategoryId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamBoardByExamCategory',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchClassStandardListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/classManagement/listStandards',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  categoryListForExamService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/categoryListForExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createExamConfigService(configuration,current_academic,AUTHTOKEN){
    configuration.current_academic = current_academic;
    const params = configuration;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/examConfiguration',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  examListConfigurationService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/ExamListConfiguration',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  examClassDetailsService(examId,current_academic,AUTHTOKEN){
    const params = {fkExamId:examId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/examClassDetails',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  getClassSectionService(classStandardId,ExamBoardId,ExamId,current_academic,AUTHTOKEN){
    const params = {classStandardId:classStandardId,ExamBoardId:ExamBoardId,ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getSectionOfClassStandard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  getSubjectByClassStandardService(classStandardId,current_academic,AUTHTOKEN){
    const params = {classStandardId:classStandardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getSubjectByClassStandard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  createExamScheduleService(schedule,current_academic,AUTHTOKEN){
    schedule.current_academic = current_academic;
    const params = schedule;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createExamScheduleByClassSection',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamScheduleByClassService(classStandardId,ExamId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {classStandardId:classStandardId,ExamId:ExamId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamScheduleOfClass',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  getCurrentDateExamScheduleService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getCurrentDateExamSchedule',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getUpcomingDateExamScheduleService(classStdId,current_academic,AUTHTOKEN){
    const params = {classStdId:classStdId,current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getUpcomingDateExamSchedule',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getCompletedExamScheduleService(classStdId,current_academic,AUTHTOKEN){
    const params = {classStdId:classStdId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getCompletedExamSchedule',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassStdForExamService(ExamId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassStdListForExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  addAndRemoveClassFromExamService(addOrRemoveClassExam,current_academic,AUTHTOKEN){
    addOrRemoveClassExam.current_academic = current_academic;
    const params = addOrRemoveClassExam;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/addAndRemoveClassFromExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createGradingSystemConfigService(gradeSysValue,current_academic,AUTHTOKEN){
    gradeSysValue.current_academic = current_academic;
    const params = gradeSysValue;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createGradingSystemConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getStudentResultsBySubjectService(examResult,current_academic,AUTHTOKEN){
    examResult.current_academic = current_academic;
    const params = examResult;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getStudentResultsBySubject',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createOrUpdateExamResultBySubjectService(examResult,current_academic,AUTHTOKEN){
    examResult.current_academic = current_academic;
    const params = examResult;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createOrUpdateExamResultsOfStudentBySubject',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  getClassSectionListService(standardId,current_academic,AUTHTOKEN) {
    const params = {classId: standardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/classSectionName',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  getStudentResultListService(classId,ExamId,current_academic,AUTHTOKEN) {
    const params = {classId: classId,ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/exam/getStudentExamResultByClassSection',
      params, {headers: headers})
      .pipe(map(res => res));
  }

  getExamBoardListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchExamBoardNameList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchExamBoardClassListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchExamBoardClassList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassStandardByExamService(examId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamId:examId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassStandardByExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassSectionByExamAndBoardService(ExamId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassSectionByExamAndBoardId',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getPublishedExamClassListService(ExamId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getPublishedExamClassList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamListByExamBoardService(ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamListByExamBoard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  publishExamResultService(data,current_academic,AUTHTOKEN){
    data.current_academic = current_academic;
    const params = data;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/publishExamResultByClass',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getSchoolExamBoardByExamService(ExamId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getSchoolExamBoardByExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassListByExamService(ExamId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassListByExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createScholasticGradeService(scholasticData,current_academic,AUTHTOKEN){
    scholasticData.current_academic = current_academic;
    const params = scholasticData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createScholasticGrade',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchScholasticListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchScholasticList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getScholasticGradeConfigService(scholasticNameId,current_academic,AUTHTOKEN){
    const params = {scholasticNameId:scholasticNameId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getScholasticGradeConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createScholasticConfigurationService(scholasticData,current_academic,AUTHTOKEN){
    scholasticData.current_academic = current_academic;
    const params = scholasticData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createScholasticConfiguration',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchScholasticConfigListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchScholasticConfigurationList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  removeScholasticConfigurationService(ScholasticConfigId,current_academic,AUTHTOKEN){
    const params = {ScholasticConfigId:ScholasticConfigId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/removeScholasticConfiguration',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  removeScholasticGradeConfigService(ScholasticNameId,current_academic,AUTHTOKEN){
    const params = {ScholasticNameId:ScholasticNameId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/removeScholasticGradeConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentListForReportCardService(classId,ExamId,current_academic,AUTHTOKEN){
    const params = {classId:classId,ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getStudentListForReportCard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentListForSemesterReportCard(details,current_academic,AUTHTOKEN){
    details.current_academic = current_academic;
    const params = details;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/studentListForSemesterReportCard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchAllScholasticConfigDetailsService(scholasticData,current_academic,AUTHTOKEN){
    scholasticData.current_academic = current_academic;
    const params = scholasticData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchAllScholasticConfigDetails',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchAllScholasticConfigDetailsForAllExamService(scholasticData,current_academic,AUTHTOKEN){
    scholasticData.current_academic = current_academic;
    const params = scholasticData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchAllScholasticConfigDetailsForAllExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getNewScholasticResultForSemReportCardByStudentService(scholasticData,current_academic,AUTHTOKEN){
    scholasticData.current_academic = current_academic;
    const params = scholasticData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getNewScholasticResultForSemReportCardByStudent',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchScholasticConfigDetailByIdService(scholasticConfigId,current_academic,AUTHTOKEN){
    const params = {scholasticConfigId:scholasticConfigId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchScholasticConfigDetailById',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getAllSubjectOfSchoolService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getAllSubjectOfSchool',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getStudentDetailByStudentService(studentId,current_academic,AUTHTOKEN){
    const params = {studentId:studentId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getStudentDetailByStudentId',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getSchoolDetailsService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/settings/schoolDetails',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamGradeSystemByExamBoardService(ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamGradeSystemByExamBoard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamBoardEvaluationTypeService(ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamBoardEvaluationType',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getTotalCountOfSubjectInResultAndSubjectService(classId,ExamId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,classId:classId,ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getTotalCountOfSubjectInResultAndSubject',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassIdListByExamIdService(ExamBoardId,ExamId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassIdListByExamId',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  publishExamResultByExamService(publishData,current_academic,AUTHTOKEN){
    publishData.current_academic = current_academic;
    const params = publishData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/publishExamResultByExams',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createMarksBifurcationConfigService(bifurcationData,current_academic,AUTHTOKEN){
    bifurcationData.current_academic = current_academic;
    const params = bifurcationData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createMarksBifurcationConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  updateMarksBifurcationConfigService(bifurcationData,current_academic,AUTHTOKEN){
    bifurcationData.current_academic = current_academic;
    const params = bifurcationData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/updateMarksBifurcationConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  marksBifurcationListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/marksBifurcationList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  marksBifurcationDetailsByIdService(marksBifurcationId,current_academic,AUTHTOKEN){
    const params = {marksBifurcationId:marksBifurcationId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/marksBifurcationDetailsById',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  removeMarksBifurcationConfigService(marksBifurcationId,current_academic,AUTHTOKEN){
    const params = {marksBifurcationId:marksBifurcationId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/removeMarksBifurcationConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getScholasticConfigListForUpdateExamService(ExamId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getScholasticConfigListForUpdateExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getCoScholasticByScholasticAndExamService(ExamId,scholasticConfigId,IsLanguage,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,scholasticConfigId:scholasticConfigId,IsLanguage:IsLanguage,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getCoScholasticByScholasticAndExam',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentScholasticResultListService(ExamId,classId,scholasticConfigId,coScholasticConfigId,scholasticEvalType,scholasticSubjectId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,classId:classId,scholasticConfigId:scholasticConfigId,coScholasticConfigId:coScholasticConfigId,scholasticEvalType:scholasticEvalType,scholasticSubjectId:scholasticSubjectId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/studentScholasticResultList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentSemesterScholasticResultListService(semesterExamId,classId,scholasticConfigId,coScholasticConfigId,scholasticEvalType,scholasticSubjectId,current_academic,AUTHTOKEN){
    const params = {semesterExamId:semesterExamId,classId:classId,scholasticConfigId:scholasticConfigId,coScholasticConfigId:coScholasticConfigId,scholasticEvalType:scholasticEvalType,scholasticSubjectId:scholasticSubjectId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/studentSemesterScholasticResultList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getSubjectAndScholasticListByClassService(ExamId,classId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,classId:classId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getSubjectAndScholasticListByClass',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getStudentListForScholasticLanguageMarksEntryService(ExamId,classId,scholasticConfigId,subjectId,current_academic,AUTHTOKEN){
    const params = {ExamId:ExamId,classId:classId,scholasticConfigId:scholasticConfigId,subjectId:subjectId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getStudentListForScholasticLanguageMarksEntry',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  insertOrUpdateStudentScholasticMarksService(studentList,current_academic,AUTHTOKEN){
    studentList.current_academic = current_academic;
    const params = studentList;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/insertOrUpdateStudentScholasticMarks',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  insertOrUpdateStudentSemesterScholasticResultService(studentList,current_academic,AUTHTOKEN){
    studentList.current_academic = current_academic;
    const params = studentList;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/insertOrUpdateStudentSemesterScholasticResult',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getScholasticGradeService(scholasticGradeId,current_academic,AUTHTOKEN){
    const params = {scholasticNameId:scholasticGradeId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getScholasticGradeConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamListForSemesterConfigService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamListForSemesterConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  createExamSemesterConfigService(semesterData,current_academic,AUTHTOKEN){
    semesterData.current_academic = current_academic;
    const params = semesterData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/createExamSemesterConfig',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamSemesterListService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamSemesterList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExamSemesterDetailByIdService(ExamSemesterId,current_academic,AUTHTOKEN){
    const params = {ExamSemesterId:ExamSemesterId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExamSemesterDetailById',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  addOrUpdateResultPublishLevelService(resultPublish,current_academic,AUTHTOKEN){
    resultPublish.current_academic = current_academic;
    const params = resultPublish;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/addOrUpdateResultPublishLevel',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchResultPublishLevelService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchResultPublishLevel',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getExternalExamListByBoardService(ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getExternalExamListByBoard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassListByExamBoardService(ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassListByExamBoardId',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getSemesterListByBoardService(ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getSemesterListByBoard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassListBySemesterIdService(ExamSemesterId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamSemesterId:ExamSemesterId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getClassListBySemesterId',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getClassListByPublishedSemesterResultService(ExamSemesterId,ExamBoardId,current_academic,AUTHTOKEN){
    const params = {ExamSemesterId:ExamSemesterId,ExamBoardId:ExamBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getPublishedSemClassList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getSemesterExamResultBySubject(semesterData,current_academic,AUTHTOKEN){
    semesterData.current_academic = current_academic;
    const params = semesterData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getSemesterExamResultBySubject',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getSubjectListOfClassBySemIdService(semesterData,current_academic,AUTHTOKEN) {
    semesterData.current_academic = current_academic;
    const params = semesterData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url + '/exam/getSubjectListOfClassBySemId',
      params, {headers: headers})
      .pipe(map(res => res));
  }
  fetchClassStandardAndSectionService(scholasticConfigId,current_academic,AUTHTOKEN){
    const params = {scholasticConfigId:scholasticConfigId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchClassAndSectionListForScholastic',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  mappingScholasticToClassesService(scholasticAndClassList,current_academic,AUTHTOKEN){
    const params = {scholasticAndClassList:scholasticAndClassList,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/mappingScholasticToClasses',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentSemesterResultDataStoreService(semesterData,current_academic,AUTHTOKEN){
    semesterData.current_academic = current_academic;
    const params = semesterData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/studentSemesterResultDataStore',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getStudentSemesterResultService(semesterData,current_academic,AUTHTOKEN){
    semesterData.current_academic = current_academic;
    const params = semesterData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getStudentSemesterResult',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  semesterResultPublishService(publishData,current_academic,AUTHTOKEN){
    publishData.current_academic = current_academic;
    const params = publishData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/semesterResultPublish',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentDetailForReportCardService(classId,studentId,ExamId,current_academic,AUTHTOKEN){
    const params = {classId:classId,studentId:studentId,ExamId:ExamId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/studentDetailForReportCard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getStudentSemesterReportCardService(classId,studentId,semesterId,current_academic,AUTHTOKEN){
    const params = {classId:classId,studentId:studentId,semesterId:semesterId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getStudentSemesterReportCard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  manageReportCardSettingsService(reportCardData,current_academic,AUTHTOKEN){
    reportCardData.current_academic = current_academic;
    const params = reportCardData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/manageReportCardSettings',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchReportCardSettingsService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchReportCardSettings',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  TeacherRemarksEntryByStudentForSemesterService(studentDetails,current_academic,AUTHTOKEN){
    studentDetails.current_academic = current_academic;
    const params = studentDetails;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/TeacherRemarksEntryByStudentForSemester',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getPublishedExamListService(examBoardId,current_academic,AUTHTOKEN){
    const params = {examBoardId:examBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getPublishedResultExamList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  getPublishedSemesterListService(examBoardId,current_academic,AUTHTOKEN){
    const params = {examBoardId:examBoardId,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/getPublishedResultSemesterList',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  studentSemesterResultsService(studentList,current_academic,AUTHTOKEN){
    const params = {studentList:studentList,current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/studentSemesterResults',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  enterSchoolCommenceService(commenceDetails,AUTHTOKEN){
    const params = commenceDetails;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/enterSchoolCommence',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  generateReportCardService(SemDetails,AUTHTOKEN){
    const params = SemDetails;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/generateReportCard',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  fetchExamPublishResultTypeService(current_academic,AUTHTOKEN){
    const params = {current_academic:current_academic};
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/fetchExamPublishResultType',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  updateExamPublishResultPercentTypeService(settingData,AUTHTOKEN){
    const params = settingData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/updateExamPublishResultPercentAndMarkType',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

  TeacherRemarksEntryForExamsService(remarksData,AUTHTOKEN){
    const params = remarksData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/TeacherRemarksEntryForExams',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  schoolExamCommenceEntryService(commenceData,AUTHTOKEN){
    const params = commenceData;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/schoolExamCommenceEntry',
      params,{ headers: headers})
      .pipe(map(res => res));
  }
  deleteEnteredExamMarksService(details,AUTHTOKEN){
    const params = details;
    const headers = new HttpHeaders().append('Content-Type','application/json').append('authToken',AUTHTOKEN);
    return this.http.post(this._url+'/exam/deleteStudentExamMarks',
      params,{ headers: headers})
      .pipe(map(res => res));
  }

}
